import React, { useState } from "react";
import { TextField, Button, Box } from "@mui/material";

/**
 * @param {(payload: { assetNumber: string, assetId?: string }) => void} onSearch
 * @param {string} [placeholder]
 */
const SearchAssetNumber = ({
  onSearch,
  placeholder = "Enter asset number",
}) => {
  const [assetNumber, setAssetNumber] = useState("");
  const [assetId, setAssetId] = useState("");

  const handleSearch = () => {
    const trimmedNumber = assetNumber.trim();
    const trimmedId = assetId.trim();
    onSearch({
      assetNumber: trimmedNumber === "" ? undefined : trimmedNumber,
      assetId: trimmedId === "" ? undefined : trimmedId,
    });
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "flex-end",
        gap: 2,
        p: 2,
        pt: 1,
      }}>
      <TextField
        label='Asset Number'
        value={assetNumber}
        onChange={(e) => setAssetNumber(e.target.value)}
        placeholder={placeholder}
        variant='outlined'
        size='small'
        sx={{ minWidth: 200, flexGrow: 1 }}
      />
      <TextField
        label='Asset Id'
        value={assetId}
        onChange={(e) => setAssetId(e.target.value)}
        placeholder='Optional'
        variant='outlined'
        size='small'
        sx={{ minWidth: 160 }}
      />
      <Button
        variant='contained'
        onClick={handleSearch}
        disabled={!assetNumber.trim() && !assetId.trim()}>
        Search
      </Button>
    </Box>
  );
};

export default SearchAssetNumber;
